























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { StatementsAndAudio } from "../../types/NewResults";
import { Lightbulb, PlayIcon } from "@/components/Icons";
import { Lexer, Token, TokenDefinition } from "@/library/Lexer";

// get tokens():
@Component({
  components: { Lightbulb, PlayIcon }
})
export default class AudioStatement extends Vue {
  @Prop() private statement!: StatementsAndAudio;

  private lexer = new Lexer([
    {
      typeName: "bold",
      regex: /^<b>([^@<>]+)<\/b>/
    },
    {
      typeName: "audio",
      regex: /^@audio([0-9]+)/
    },
    {
      typeName: "text",
      regex: /^([^@<>]+)/
    }
  ]);
  private isEmpty(obj: Object) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }
  private onPlay(tag: any) {
    if (this.statement && this.statement.audio) {
      let toplay = this.statement.audio[tag.type + tag.value];
      this.$emit("play", toplay);
    }
  }
  get tokens(): Token[] {
    return this.lexer.lex(this.statement.statements);
  }
}
